export class SharingVendorNotFoundError extends Error { }
